import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";
import Header from "./Header";
import { useWindowSize } from "../../hooks/useWindowSize";
import useIsLandscape from "../../hooks/useIsLandscape";

const NO_LAYOUT_PATHS = [
  "/login",
  "/forgot-password",
  "/enter-code",
  "/reset-password",
  "/not-found",
  "/verification",
  "/change-password",
  "/change-password/",
  "/select-clinic",
];
const TABLET = 1024;

export default function MainLayout() {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/$/, "");

  const needsLayout = !NO_LAYOUT_PATHS.includes(pathname);
  const [isNeedLayout, setIsNeedLayout] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const isMobile = useWindowSize(TABLET);
  const isLandscape = useIsLandscape();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (needsLayout && storedUser) {
      setIsNeedLayout(true);
    } else {
      setIsNeedLayout(false);
    }

    document.documentElement.classList.remove("mdl-js");
  }, [pathname, needsLayout]);

  if (!needsLayout) {
    return <Outlet />;
  }

  if (!isNeedLayout) {
    return null;
  }

  const shouldHideHeader = isMobile && isLandscape;

  return (
    <div>
      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      {!shouldHideHeader && <Header isOpenSlide={isOpen} />}
      <main
        className={`
          bg-[#ffffff] transition-all duration-300 px-1 absolute
          ${
            isMobile
              ? `left-0 w-full ${shouldHideHeader ? "top-0" : "top-[137px]"}`
              : `left-[139px] top-[109px] w-[calc(100%-139px)]`
          }
          ${isOpen ? "md:ml-33" : "md:ml-0"}`}
      >
        <Outlet />
      </main>
    </div>
  );
}
